import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RoutingModule } from './routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './footer.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IconComponent } from './icon.component'; // Standalone component
import { HttpClientModule } from '@angular/common/http';
import { SharedService } from './shared.service';
import { customPaginator } from './providers/custompaginator';
import { DatePipe } from '@angular/common';
import { BreadcrumbsComponent } from './components/breadcrumbs.component';
import { MatPaginatorIntl } from "@angular/material/paginator"
import { PublicShadcnToasterComponent } from './components/public-shadcn-toaster.component';
import { ToastService } from './admin/services/toast.service';
import { SeoPageSlugCacheService } from './services/seo-page-slug-cache.service';
import { APP_INITIALIZER } from '@angular/core';

@NgModule({
    declarations: [AppComponent],
    // Only what the app shell renders. Pages are standalone and bring their own imports,
    // so routes can load them on demand (see routing.module.ts).
    imports: [
        BrowserModule,
        RoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        IconComponent,
        BreadcrumbsComponent,
        FooterComponent,
        PublicShadcnToasterComponent,
    ],
    providers: [
        SharedService,
        DatePipe,
        ToastService,
        { provide: MatPaginatorIntl, useValue: customPaginator() },
        {
            provide: APP_INITIALIZER,
            multi: true,
            deps: [SeoPageSlugCacheService],
            useFactory: (cache: SeoPageSlugCacheService) => () => cache.initialize(),
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
